module.exports = "#version 300 es\n\nin vec4 vs_Pos;\n\nvoid main() {\n  gl_Position = vs_Pos;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/sky-vert.glsl
// module id = 73
// module chunks = 0